import { AppDispatch } from 'src/app/store'
import * as api from './footprintApi'
import * as reducers from './footprintSlice'

export const getAllFootPrintTypes = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setFootPrintTypesLoading(true))
    const data = await api.getFootPrintTypes()
    dispatch(reducers.setFootPrintTypesLoading(false))
    dispatch(reducers.setFootPrintTypesResponse(data))
  } catch (error) {
    dispatch(reducers.setFootPrintTypesError(error))
  }
}

export const getMyFootPrintList = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setFootPrintLoading(true))
    const data = await api.getMyFootPrintListAPI()
    dispatch(reducers.setFootPrintLoading(false))
    dispatch(reducers.setFootPrintResponse(data))
  } catch (error) {
    dispatch(reducers.setFootPrintError(error))
  }
}

export const createFootPrint = (payload: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setCreateFootPrintLoading(true))
    const newFootPrint = await api.createFootPrintAPI(payload)
    dispatch(reducers.setCreateFootPrintLoading(false))
    dispatch(reducers.setCreateFootPrintSuccess(true))
    dispatch(reducers.addFootPrintToList(newFootPrint))
  } catch (error) {
    dispatch(reducers.setCreateFootPrintSuccess(false))
    dispatch(reducers.setFootPrintError(error))
  }
}

export const updateFootPrint = (id: number, payload: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setUpdateFootPrintLoading(true))
    const newFootPrint = await api.updateFootPrintAPI(id, payload)
    dispatch(reducers.setUpdateFootPrintLoading(false))
    dispatch(reducers.setUpdateFootPrintSuccess(true))
    dispatch(reducers.updateFootPrintList(newFootPrint))
    dispatch(reducers.resetUpdateFootPrintState())
  } catch (error) {
    dispatch(reducers.setUpdateFootPrintSuccess(false))
    dispatch(reducers.setUpdateFootPrintError(error))
  }
}

export const deleteFootPrint = (id: number) => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setDeleteFootPrintLoading(true))
    await api.deleteFootPrintAPI(id)
    dispatch(reducers.setDeleteFootPrintSuccess(true))
    dispatch(reducers.deleteFootPrintItemFromList(id))
  } catch (error) {
    dispatch(reducers.setDeleteFootPrintLoading(false))
    dispatch(reducers.setDeleteFootPrintLoading(false))
  }
}

export const getFootPrintVsCompensationData = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setFootPrintVsCompensationLoading(true))
    const data = await api.getFootPrintVsCompensationDataAPI()
    dispatch(reducers.setFootPrintVsCompensationData(data))
    dispatch(reducers.setFootPrintVsCompensationLoading(false))
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getFootPrintHistory = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(reducers.setFootPrintHistoryLoading(true))
    const { data } = await api.getFootPrintHistoryAPI()
    dispatch(reducers.setFootPrintHistoryData(data))
    dispatch(reducers.setFootPrintHistoryLoading(false))
  } catch (error) {
    return Promise.reject(error)
  }
}
